import '../../../estilos/contador-de-mensualidad.css';

/**
 * EL CONTADOR DE MENSUALIDAD «n/m» — PIEZA COMPARTIDA ÚNICA
 * (incremento 18/21, RNF-132, RN-707, D-393).
 *
 * POR QUÉ EXISTE ESTE COMPONENTE Y NO UN ARREGLO CASO POR CASO: el contador
 * aparece en la tarjeta, en la compra a meses y —cuando exista— en el préstamo.
 * Si cada pantalla pinta el suyo, la próxima regla de contraste o de distinción se
 * aplica en unas y se olvida en otras. Aquí hay UNA implementación; las pantallas
 * la consumen.
 *
 * LAS DOS EXIGENCIAS SON DOS, Y SE CUMPLEN LAS DOS:
 *
 *   1. LEGIBILIDAD (RNF-132, D-393) · El número va en BLANCO sobre el fondo del
 *      recuadro, con relación de contraste ≥ 4.5:1 en tema claro Y en tema oscuro
 *      —la regla que el proyecto ya tiene, RNF-023/D-08, aplicada al elemento que
 *      la incumplía—, y legible a 320 px (RNF-069). El gris sobre morado del
 *      prototipo queda derogado como color del texto.
 *
 *   2. DISTINCIÓN HISTÓRICA / NORMAL (RN-707) · El gris no era adorno: distinguía
 *      la mensualidad histórica. Esa distinción NO SE PIERDE, CAMBIA DE MEDIO, y
 *      NUNCA vuelve a descansar en el color. Son CUATRO señales independientes,
 *      más la leyenda:
 *        · borde punteado      (CSS, `.ct.hist`)
 *        · relleno apagado     (CSS, `.ct.hist`)
 *        · marca de visto      (CSS, `.ct.hist::before`, decorativa)
 *        · etiqueta textual    (este componente, disponible para lector de pantalla)
 *        · leyenda en pantalla (`LeyendaDeContadores`, abajo)
 *      Quitar el gris del texto no elimina ningún otro rasgo distintivo.
 *
 * ESTE COMPONENTE NO CALCULA NADA (RNF-038, RNF-059): el texto «3/12» llega YA
 * ARMADO del servidor y aquí no se concatena, no se divide y no se interpreta.
 *
 * LA SEMÁNTICA COMPLETA DE «HISTÓRICA» ES DEL INCREMENTO 19, que es su dueño
 * (RN-707): una mensualidad ya cargada antes de usar la aplicación, que no imputa
 * ni suma deuda. Este incremento fija la REGLA DE PRESENTACIÓN y la aplica en lo
 * que toca; el 19 y el 20 la heredan al construir sus contadores pasando
 * `esHistorica`.
 */
export function ContadorDeMensualidad({ contador, esHistorica = false, datoDePrueba = 'contador' }) {
  if (contador === null || contador === undefined || String(contador).trim() === '') return null;

  return (
    <span
      className={`ct${esHistorica ? ' hist' : ''}`}
      data-prueba={datoDePrueba}
      data-historica={esHistorica ? 'si' : 'no'}
    >
      {contador}
      {/* ETIQUETA TEXTUAL (RN-707). Va dentro del recuadro y disponible para el
          lector de pantalla: lo significativo no se codifica solo con color ni con
          un ícono. En la mensualidad normal no se pinta ninguna etiqueta, y esa
          ausencia es la otra mitad de la distinción. */}
      {esHistorica && <span className="ct-eti"> · ya cargada</span>}
    </span>
  );
}

/**
 * LEYENDA DE LOS CONTADORES (RN-707). Explica en palabras qué significa el
 * recuadro punteado, para que la distinción se pueda leer sin ver los colores ni
 * comparar dos recuadros entre sí.
 *
 * Solo se pinta cuando hay al menos una mensualidad histórica a la vista: una
 * leyenda que explica algo que no está en pantalla es ruido.
 */
export function LeyendaDeContadores({ hayHistoricas = false }) {
  if (!hayHistoricas) return null;

  return (
    <span className="ayuda" data-prueba="leyenda-de-contadores">
      Los recuadros con <b>borde punteado y marca de visto</b> son mensualidades que ya habías
      pagado antes de usar la aplicación.
    </span>
  );
}
